export default __webpack_public_path__ + "static/media/JAS0200.34I-43422_-26086_0.a96dd575.jpg";